import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAfsls, fetchAssetClassOrder, fetchAssetClassOverride } from './thunks';
import { Afsl, ReportSettingsState, AssetClassOrderItem, AssetClassOverrideItem } from './types';

export const initialState: ReportSettingsState = {
  afsls: [],
  afslId: undefined,
  assetClassOrderGridState: [],
  assetClassOverrideGridState: [],
};

export const reportSettingsSlice = createSlice({
  name: '@@templates/report-settings/fetch-initial',
  initialState,
  reducers: {
    setAfslId: (state, action: PayloadAction<number | undefined>) => {
      state.afslId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAssetClassOrder.fulfilled, (state: ReportSettingsState, action: PayloadAction<AssetClassOrderItem[]>) => {
      state.assetClassOrderGridState = action.payload;
    });
    builder.addCase(fetchAssetClassOverride.fulfilled, (state: ReportSettingsState, action: PayloadAction<AssetClassOverrideItem[]>) => {
      state.assetClassOverrideGridState = action.payload;
    });
    builder.addCase(fetchAfsls.fulfilled, (state, action: PayloadAction<Afsl[]>) => {
      state.afsls = action.payload.sort((a, b) => a.name.localeCompare(b.name));
      if (!state.afslId && state.afsls.length > 0) {
        state.afslId = state.afsls[0].id;
      }
    });
  },
});
